define( function() {
	"use strict";

	return function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/isWindow.js
// module id = 54
// module chunks = 0